<template>
  <div id="service-view">

    <!-- CONTENT -->

    <div id="wideContent">

      <div class="box">

        <div class="boxContent">

          <h1>Služby</h1>

          <p>
            Kompletní přehled námi nabízených služeb naleznete v
            přehledném seznamu níže. Pokud máte zájem o nějakou
            nadstandardní službu, <router-link to="/contact">kontaktujte nás</router-link>
            prosím a my se Vám budeme snažit vyhovět. Jako
            doplňkovou službu v salonu poskytujeme prodej kosmetiky a
            potřeb pro pejsky a kočičky.
        </p>

          <p>
            <b>U problematičtějších pejsků vítáme přítomnost páníčka či paničky po dobu procedury.</b>
          </p>

          <br />

          <table cellspacing="1" cellpadding="1" border="0"
                 width="100%" class="modernTable">
            <thead>
            <tr>
              <td colspan="2" style="text-align: center;">Masáže psů</td>
              <td style="text-align: center;">Cena</td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Malá plemena (do 30 cm výšky)</td>
              <td style="text-align: center;">doba trvání 30 min.</td>
              <td style="text-align: center;">200 Kč</td>
            </tr>
            <tr>
              <td>Střední plemena (30 - 45 cm výšky)</td>
              <td style="text-align: center;">doba trvání 45 min.</td>
              <td style="text-align: center;">300 Kč</td>
            </tr>
            <tr>
              <td>Velká plemena(45 cm a výše)</td>
              <td style="text-align: center;">doba trvání 60 min.</td>
              <td style="text-align: center;">400 Kč</td>
            </tr>
            </tbody>
          </table>
          <p style="padding-left: 5px">
            <b>Bližší informace ohledně psích masáží naleznete <router-link to="/massage">zde</router-link>.</b>
          </p>

          <br />


          <table cellspacing="1" cellpadding="1" border="0"
                 width="100%" class="modernTable">
            <thead>
            <tr>
              <td style="text-align: center;">Druh plemene</td>
              <td style="text-align: center;">Koupání</td>
              <td style="text-align: center;">Stříhání <b>*</b></td>
              <td style="text-align: center;">Trimování <b>*</b></td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Pudl toy</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">500 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td style="text-align: left;">Pudl trpasličí</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Pudl střední</td>
              <td style="text-align: center;">250 Kč</td>
              <td style="text-align: center;">650 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Pudl královský</td>
              <td style="text-align: center;">400 Kč</td>
              <td style="text-align: center;">800 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Kokr anglický</td>
              <td style="text-align: center;">300 Kč</td>
              <td style="text-align: center;">650 Kč</td>
              <td style="text-align: center;">1100 Kč</td>
            </tr>
            <tr>
              <td>Kokr americký</td>
              <td style="text-align: center;">300 Kč</td>
              <td style="text-align: center;">650 Kč</td>
              <td style="text-align: center;">1100 Kč</td>
            </tr>
            <tr>
              <td>Bišonek</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Boloňský psík</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Maltézský psík</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Knírač malý</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;">800 Kč</td>
            </tr>
            <tr>
              <td>Knírač střední</td>
              <td style="text-align: center;">250 Kč</td>
              <td style="text-align: center;">650 Kč</td>
              <td style="text-align: center;">1100 Kč</td>
            </tr>
            <tr>
              <td>Knírač velký</td>
              <td style="text-align: center;">400 Kč</td>
              <td style="text-align: center;">800 Kč</td>
              <td style="text-align: center;">1300 Kč</td>
            </tr>
            <tr>
              <td>Jorkšírský teriér</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">500 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Teriér malý</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;">800 Kč</td>
            </tr>
            <tr>
              <td>Teriér střední</td>
              <td style="text-align: center;">250 Kč</td>
              <td style="text-align: center;">650 Kč</td>
              <td style="text-align: center;">1100 Kč</td>
            </tr>
            <tr>
              <td>Teriér velký</td>
              <td style="text-align: center;">400 Kč</td>
              <td style="text-align: center;">800 Kč</td>
              <td style="text-align: center;">1300 Kč</td>
            </tr>
            <tr>
              <td>Shih-tzu</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>West teriér</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;">900 Kč</td>
            </tr>
            <tr>
              <td>Jezevčík</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">500 Kč</td>
              <td style="text-align: center;">800 Kč</td>
            </tr>
            <tr>
              <td>Kříženec malý</td>
              <td style="text-align: center;">200 Kč</td>
              <td style="text-align: center;">600 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Kříženec střední</td>
              <td style="text-align: center;">250 Kč</td>
              <td style="text-align: center;">650 Kč</td>
              <td style="text-align: center;"></td>
            </tr>
            <tr>
              <td>Kříženec velký</td>
              <td style="text-align: center;">400 Kč</td>
              <td style="text-align: center;">800 Kč</td>
              <td style="text-align: center;">1300 Kč</td>
            </tr>
            <tr>
              <td>Ostatní velká plemena</td>
              <td style="text-align: center;">400 Kč</td>
              <td style="text-align: center;">800 Kč</td>
              <td style="text-align: center;">1300 Kč</td>
            </tr>
            </tbody>
          </table>
          <p>
            <b>*Stříhání drápků a čištění očí a uší jsou již zahrnuty v ceně stříhání.</b><br />
            <b>*Stříhání a trimování pouze společně s koupáním.</b>
          </p>

          <br />

          <table cellspacing="1" cellpadding="1" border="0"
                 width="100%" class="modernTable withHeader">
            <thead>
            <tr>
              <td style="text-align: center;">Služba</td>
              <td style="text-align: center;">Cena</td>
              <td style="text-align: center;">Popis</td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Rozčesávání zplst. srsti</td>
              <td style="text-align: center;">300 Kč / hod.</td>
              <td>Vyžaduje předchozí domluvu</td>
            </tr>
            <tr>
              <td>Stříhání zplst. srsti</td>
              <td style="text-align: center;">300 Kč</td>
              <td>Účtováno dodatečně ke stříhání</td>
            </tr>
            <tr>
              <td>Přítomnost blech u psa</td>
              <td style="text-align: center;">150 - 300 Kč</td>
              <td>Poplatek dezinfekce a odblešení</td>
            </tr>
            <tr>
              <td>Odstranění klíšťat</td>
              <td style="text-align: center;">30 Kč / kus</td>
              <td></td>
            </tr>
            <tr>
              <td>Čištění očí</td>
              <td style="text-align: center;">50 Kč</td>
              <td></td>
            </tr>
            <tr>
              <td>Čištění uší</td>
              <td style="text-align: center;">50 Kč</td>
              <td></td>
            </tr>
            <tr>
              <td>Stříhání drápků</td>
              <td style="text-align: center;">100 Kč</td>
              <td></td>
            </tr>
            <tr>
              <td>Depilace ušního zvukovodu</td>
              <td style="text-align: center;">100 Kč</td>
              <td></td>
            </tr>
            </tbody>
          </table>

          <br />
          <br />
          <br />

          <p style="text-align: center;">Ceny pro uvedené služby jsou pouze orientační.</p>

        </div>
      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

    </div>

    <!-- /CONTENT -->

  </div>
</template>

<script>
  export default {
    name: 'service-view',
    head: {
      title: { inner: 'Psí Salon Jája', separator: '-', complement: 'námi nabízené služby a jejich ceny' },
      meta: [
        { id: 'description', content: 'Nabízíme koupání, stříhání a trimování psů. Případně na vyžádání i jiné služby. V salonu rovněž nabízíme prodej kosmetiky a potřeb pro pejsky a kočičky.' },
        { id: 'keywords', content: 'služby, ceny, ceník, stříhání, koupání' }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// ServiceView.vue?1eb3361f